// Legacy JS module (verbatim CookiePolicy content factory), no types: typed loosely below.
import cookiePageContentDefault from 'root/src/client/web/static/CookiePolicy/pageContent';
import { LegalPageLayout } from 'root/src/client/v2/_pages/legal/redesign/LegalPageLayout';
import { LegalProse } from 'root/src/client/v2/_pages/legal/redesign/LegalProse';
import { LegalSection } from 'root/src/client/v2/_pages/legal/redesign/LegalSection';
import { legalClasses } from 'root/src/client/v2/_pages/legal/redesign/legalClasses';
const cookiePageContent = cookiePageContentDefault;
// Cookie Policy. REUSES the legacy `CookiePolicy/pageContent` factory verbatim (legally significant
// text), fed the redesign `legalClasses` map (its definition-list block uses `classes.wrapper`). No
// TOC. The render mirrors the legacy index: each entry is a `<section>` with an `<h3>` then the body.
export const RedesignCookiePolicyPage = () => {
    const sections = cookiePageContent(legalClasses);
    return (<LegalPageLayout title="Cookie Policy" effectiveDate="Effective January 31, 2019">
			<LegalProse definitionStrong>
				{sections.map(({ title, text }) => (<LegalSection key={String(title)} title={title}>
						{text}
					</LegalSection>))}
			</LegalProse>
		</LegalPageLayout>);
};
